const SILENCED_METHODS = [
  'log',
  'info',
  'debug',
  'trace',
  'table',
  'warn',
  'error',
  'group',
  'groupCollapsed',
  'groupEnd',
  'time',
  'timeEnd',
] as const;

type SilencedMethod = (typeof SILENCED_METHODS)[number];
type MutableConsole = Console & Record<SilencedMethod, (...args: unknown[]) => void>;

const DEV_BANNER = String.raw`
  _______  _____  __
 /_  __// /  _// / /
  / /    _/ /   / /__
 /_/    /___// /____//

 Today I Learn - Dance. Discover. Belong.
 JOIN OUR COMMUNITY: https://t.me/+6GgCgcuYiDVlNTQ1
`;

const DEV_BANNER_KEY = 'til:console-banner-shown';

/**
 * Replace every console method with a no-op.
 *
 * Exported separately from installConsoleGuard so the suppression path is
 * unit-testable and so it is provable that the logger's monitoring delivery
 * does not depend on console output (see logger.sendToMonitoring, which
 * dispatches straight to fetch).
 */
export function suppressConsole(): void {
  const noop = (): void => {};
  SILENCED_METHODS.forEach((method) => {
    (console as MutableConsole)[method] = noop;
  });
}

export function installConsoleGuard(): void {
  if (typeof window === 'undefined') {
    return;
  }

  const mode = import.meta.env.MODE;
  if (mode === 'test') {
    return;
  }

  if (import.meta.env.PROD) {
    suppressConsole();
    return;
  }

  try {
    if (!sessionStorage.getItem(DEV_BANNER_KEY)) {
      sessionStorage.setItem(DEV_BANNER_KEY, '1');
      // eslint-disable-next-line no-console -- Console utility intentionally using console
      console.log(DEV_BANNER);
    }
  } catch {
    // eslint-disable-next-line no-console -- Console utility intentionally using console
    console.log(DEV_BANNER);
  }
}
